import React, {useMemo, useState} from "react";
import {IState} from "./types/notes-card.types";
import {fetchAllNotes, markStatus} from "./action/notes-card.actions";
import NotesCardView from "./notes-card.view";
import {useBaseComponent} from "../../../base/base-component";
import {Note, NoteStatus} from "../../../domains/models/note";
import {useNavigate} from 'react-router-dom';
import '../../../styles/component/dashboard/dashboard-note-card.scss';


const NotesCard = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const {state, updateState} = useBaseComponent<{}, IState>({}, {
        initialState: () => ({
            data: []
        }),
        onInit: () => onInit()
    });

    async function onInit() {
        setLoading(true)
        try {
            const res = await fetchAllNotes();
            updateState("data", res);
        } catch (e) {
            console.log("Error while fetching notes")
        } finally {
            setLoading(false)
        }
    }

    function upsertNotes(note: Note) {
        const exists = state.data.some((e) => e.id === note.id);
        if (exists) {
            updateState(
                'data',
                state.data.map((i) => (i.id === note.id ? note : i))
            );
        } else {
            updateState('data', [note, ...state.data]);
        }
    }

    function navigateToNotePage() {
        navigate('/my-notes')
    }

    async function handleMarkStatus(id: string) {
        let noteStatus: NoteStatus;
        const note = state.data.find((n) => n.id === id)!;
        if (note.status === 'ACTIVE') {
            noteStatus = 'COMPLETED'
            note.status = 'COMPLETED';
        } else {
            noteStatus = 'ACTIVE'
            note.status = 'ACTIVE';
        }
        await markStatus(id, noteStatus);
        updateState('data', [
            ...state.data.map((n) => n.id === id ? note : n)
        ]);
    }

    const filterNotes = useMemo(() => {
        const statusValue = {
            ACTIVE: 1,
            COMPLETED: 2
        }
        return state.data.sort((a, b) => statusValue[a.status] - statusValue[b.status])
    }, [state.data])

    return (
        <NotesCardView
            loading={loading}
            notes={filterNotes}
            upsertNotes={upsertNotes}
            navigateToNotePage={navigateToNotePage}
            handleMarkStatus={handleMarkStatus}
        />
    );
};

export default NotesCard;
